import SelectAppointmentOptionPage from "./SelectAppointmentOptionPage";

export default SelectAppointmentOptionPage;

export * from "./SelectAppointmentOptionPage";
